import { FCC } from "@/types/common";
import { Typography } from "@mui/material";
import { InnerBox } from "@/components/elements/InnerBox";
import { divider } from "@/theme/colors";
import { TGetPartnerDto } from "@/api/services/main/partner/dtos/get-partner.dto";
import { PartnerInfoItem } from "@/features/partner/components/partner-detail/PartnerInfoItem";

type TPartnerAdditionalInfoProps = {
  partner: TGetPartnerDto;
};

export const PartnerAdditionalInfo: FCC<TPartnerAdditionalInfoProps> = ({ partner }) => {
  return (
    <InnerBox title={<Typography variant="sub16Bold">その他の情報</Typography>} showDivider={false} borderColor={divider.high} sx={{ gap: "24px" }}>
      <PartnerInfoItem label="メモ" value={partner.memo} type="textArea" showDivider={false} />
    </InnerBox>
  );
};
